// extracted by mini-css-extract-plugin
export default {"main":"app-main_main__n7Z9i","content":"app-main_content__ZH-Jg","wrapper":"app-main_wrapper__UEXVd"};